import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, take } from 'rxjs';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class AcDialogService {
  constructor(private _dialog: MatDialog) {}

  confirmationDialog(title: string, message?: string, action?: string): Observable<boolean | undefined> {
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: {
        title,
        message,
        action,
      },
      disableClose: true,
    });
    return dialogRef.afterClosed().pipe(take(1));
  }
}
